"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.galleryTags.name': 'Gallery Tags',
    'tools.galleryTags.description': 'Manage and organize gallery content with tags',
};
